import { render, staticRenderFns } from "./PaSalePage.vue?vue&type=template&id=5a6bddf2&scoped=true"
import script from "./PaSalePage.vue?vue&type=script&lang=js"
export * from "./PaSalePage.vue?vue&type=script&lang=js"
import style0 from "./PaSalePage.vue?vue&type=style&index=0&id=5a6bddf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6bddf2",
  null
  
)

export default component.exports